import { useState } from "react";

export default function BlockAlert({ block, setBlocks, updateBlock, className, isEditing, settingsFunnel }) {

    if(block.content == null){
        block.content = '<p class="ql-align-center"><strong>Atenção:</strong> <span>Esse é um alerta!</span></p>';
    }
 
    let editedContent = block.content;
    let bgAlert = "";
    let colorAlert = "";
    let paddingAlert = "";


    editedContent = editedContent.replace(/ql-align-center/g, "text-center");
    editedContent = editedContent.replace(/ql-align-right/g, "text-right");
    editedContent = editedContent.replace(/ql-align-justify/g, "text-justify");
    editedContent = editedContent.replace(/ql-align-left/g, "text-left");

    if(block.alertType == null){
        block.alertType = 'alert-danger';
    }

    if(block.alertSize == null){
        block.alertSize = 'small';
    }
  

    if(block.alertType == 'alert-info'){
        bgAlert = "#bfdbfe"; // hex for Tailwind's bg-blue-200
        colorAlert = "#2563eb";
    }else if(block.alertType == 'alert-success'){
        bgAlert = "#d1fae5"; // hex for Tailwind's bg-green-200
        colorAlert = "#16a34a";
    }else if(block.alertType == 'alert-warning'){
        bgAlert = "#f5b642"; // hex for Tailwind's bg-yellow-200
        colorAlert = "#523a0f";
    }else if(block.alertType == 'alert-danger'){
        bgAlert = "#fee2e2"; // hex for Tailwind's bg-red-200
    colorAlert = "#dc2626";
    }else if(block.alertType == 'theme'){
        bgAlert = settingsFunnel.primaryColor; // hex for Tailwind's bg-red-200
        colorAlert = settingsFunnel.buttonTextColor;

        console.log('colorAlert', block.alertType)
    }else if(block.alertType == 'light'){
        bgAlert = "#f5f5f5"; // hex for Tailwind's bg-red-200
        colorAlert = "#523a0f";

        console.log('colorAlert', block.alertType)
    }else if(block.alertType == 'dark'){
        bgAlert = "#523a0f"; // hex for Tailwind's bg-red-200
        colorAlert = "#f5f5f5";

        console.log('colorAlert', block.alertType)
    }

    if(block.alertSize == 'small'){
        paddingAlert = "0.05rem";
    }else if(block.alertSize == 'normal'){
        paddingAlert = "0.3rem";
    }else if(block.alertSize == 'large'){
        paddingAlert = "0.8rem";
    }else if(block.alertSize == 'xlarge'){
        paddingAlert = "1.25rem";
    }

    let borderAlert = "none";


    if(block.alertBorder == undefined){
        block.alertBorder = 'none';
    }

    if(block.alertBorder == 'none'){
        borderAlert = "none";
    }else if(block.alertBorder == 'normal'){
        borderAlert = "border-2 border-green-600";
    }else if(block.alertBorder == 'dashed'){
        borderAlert = "border-2 border-dashed border-green-600";
    }



    return (
      <div className={`rounded-xl   w-full   `}>
        <div className={`w-full  p-2 bg-green-500 rounded-lg  ${borderAlert}`} style={{backgroundColor: bgAlert, color: colorAlert, paddingTop: paddingAlert, paddingBottom: paddingAlert}} id={`alert-bg-${block.id}`}>
          <div id={`alert-${block.id}`}
            className={`text-lg ql-editor `}
            dangerouslySetInnerHTML={{ __html: editedContent || '' }}
            style={{pointerEvents: 'none'}}
          ></div>
        </div>
      </div>
    );
  
}